/**
 * `/` ルートの placeholder。本実装は別 PR で行う。
 *
 * 注: Figma の `Page:Top` は別概念（板単位の list view）で、
 * features/catalog 配下の `CatalogListView` として実装される。
 * この `TopPage` は単なる landing placeholder。
 */
export const TopPage: React.FunctionComponent = () => {
  return <div>toppage</div>;
};
